/*
Copyright (c) 2012-2026 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved.
NOTICE: All information contained herein is, and remains the property of GRAB.
The intellectual and technical concepts contained herein are confidential,
proprietary and controlled by GRAB and may be covered by patents, patents in process,
and are protected by trade secret or copyright law.

You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate,
adapt or change this material in any way unless prior written permission is obtained from GRAB.
Access to the source code contained herein is hereby forbidden to anyone except current GRAB
employees or contractors with binding Confidentiality and Non-disclosure agreements explicitly
covering such access.

The copyright notice above does not evidence any actual or intended publication or disclosure of
this source code, which includes information that is confidential and/or proprietary,
and is a trade secret, of GRAB.

ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR
THROUGH USE OF THIS SOURCE CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED,
AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS
SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE,
DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,
IN WHOLE OR IN PART.
*/
import React, { FC, useEffect } from "react"
import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch,
} from "react-router-dom"

import { isDevBuildOrBranchPreview } from "constants/domain"
import { HOME, LOGIN, LOGIN_SUCCESS, LOGOUT } from "constants/routes"
import { Home } from "pages/home"
import { Login } from "pages/login"
import { LoginSuccess } from "pages/login/LoginSuccess"
import { devLogout, isAuthenticated, logout } from "utils/authentication"
import { sessionInfo } from "utils/session"
import { storageHelper } from "utils/storage"

const LogoutRoute: FC = () => {
  useEffect(() => {
    devLogout()
    window.location.replace(LOGIN)
  }, [])

  return null
}

const AuthenticatedRoutes: FC = () => {
  const authentication = isAuthenticated()
  const userCountry = storageHelper.getUserCountry()
  if (!authentication || userCountry == null) {
    logout()
    if (
      window.location.pathname !== "/" &&
      window.location.pathname !== LOGOUT
    ) {
      window.location.href = LOGOUT
    }
    return null
  }
  sessionInfo.setUserCurrentCountryCode(userCountry)
  if (
    !authentication ||
    userCountry == null ||
    window.location.pathname === LOGOUT
  )
    return null

  return <Route component={Home} />
}

export const RootRouter = () => {
  const isLoginRouteEnabled = isDevBuildOrBranchPreview()

  return (
    <Router>
      <Switch>
        {isLoginRouteEnabled && <Redirect exact from={HOME} to={LOGIN} />}
        {isLoginRouteEnabled && <Route exact path={LOGIN} component={Login} />}
        {isLoginRouteEnabled && (
          <Route exact path={LOGOUT} component={LogoutRoute} />
        )}
        {isLoginRouteEnabled && (
          <Route exact path={LOGIN_SUCCESS} component={LoginSuccess} />
        )}
        <Route component={AuthenticatedRoutes} />
      </Switch>
    </Router>
  )
}
